module.exports = __webpack_public_path__ + "static/pillar-fleet-40e837560552ccba0aeb828db46e7689.jpg";